export const selectPayments = (state) =>
  state.get('paymentRequest/detailContainer').get('payments').toJS();
export const selectPaymentsIsLoading = (state) =>
  state.get('paymentRequest/detailContainer').get('paymentsIsLoading');
export const selectPaymentsErrorMessage = (state) =>
  state.get('paymentRequest/detailContainer').get('paymentsErrorMessage');
export const selectarchivingPaymentRequest = (state) =>
  state.get('paymentRequest/detailContainer').get('archivingPaymentRequest');
